import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Textarea } from "@/components/elements/Textarea";
import { TMatchForm } from "@/features/match/types/MatchForm";
import {
  CollapsibleSectionHeader,
  useCollapsible,
} from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Collapse, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";

type TMatchCustomSystemInfoFormProps = {
  defaultValues: Partial<TMatchForm>;
};

export const MatchCustomSystemInfoForm: FCC<TMatchCustomSystemInfoFormProps> = ({ defaultValues: _defaultValues }) => {
  const { control } = useFormContext<TMatchForm>();
  const { expanded, toggle } = useCollapsible();

  return (
    <InnerBox showDivider={false} padding={3} borderColor={divider.high}>
      <CollapsibleSectionHeader title="システムカスタマイズ" expanded={expanded} onToggle={toggle} />

      <Collapse in={expanded}>
        <Grid mt={2} container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="jobInputRule">
              <Textarea minRows={5} maxRows={10} />
            </FormField>
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="talentInputRule">
              <Textarea minRows={5} maxRows={10} />
            </FormField>
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="talentCharacteristicMemoTemplate">
              <Textarea minRows={5} maxRows={10} />
            </FormField>
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="talentInterviewEvaluationTemplate">
              <Textarea minRows={5} maxRows={10} />
            </FormField>
          </Grid>
        </Grid>
      </Collapse>
    </InnerBox>
  );
};
